export default "__VITE_ASSET__DIBhgq10__"